import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { ReportService } from 'app/services/report.service';
import { SpinnerService } from 'app/services/spinner.service';

@Component({
  selector: 'ms-candidate-entry',
  templateUrl: './candidate-entry.component.html',
  styleUrls: ['./candidate-entry.component.css']
})
export class CandidateEntryComponent implements OnInit {

  submitted = false;
  error = false;
  success: Boolean = false;
  showForm: Boolean = false;
  registrationForm: FormGroup;
  requestNumber: any;
  uuid: any;
  minDate: any;
  maxDate: any;
  modalReference: any;

  constructor(
    private router: Router,
    private reportService: ReportService,
    private route: ActivatedRoute,
    private commonUtilService: CommonUtilService,
    private formBuilder: FormBuilder,
    public datepipe: DatePipe,
    private spinnerService: SpinnerService,
    private modalService: NgbModal) { }

  ngOnInit(): void {

    this.spinnerService.start();

    this.commonUtilService.translateLang("HRWE.PAGE_TITLE.CANDIDATE_DETAIL");

    var today = new Date();
    this.maxDate = this.datepipe.transform(today.setFullYear(today.getFullYear() - 18), 'yyyy-MM-dd');
    this.minDate = this.datepipe.transform(today.setFullYear(today.getFullYear() - 68), 'yyyy-MM-dd');

    this.requestNumber = this.route.snapshot.paramMap.get('requestNumber');

    this.uuid = this.route.snapshot.paramMap.get('uuid');

    this.registrationForm = this.registrationFormBuilder(this.formBuilder);

    this.reportService.privacyCheckedorNot(this.requestNumber, this.uuid).subscribe(data => {
      /* console.log(data); */
      this.showForm = data;
      if(!this.showForm){
        this.goToPrivacyPage();
      }
      this.spinnerService.stop();
    });

  }

  goToPrivacyPage() {
    this.router.navigate(['/report/' + this.requestNumber + '/' + this.uuid ]);
  }

  goToSuccessPage() {
    this.router.navigate(['/report/' + this.requestNumber + '/' + this.uuid + '/success']);
  }

  get f() { return this.registrationForm.controls; }

  get val() { return this.registrationForm.value; }

  registrationFormBuilder = (formBuilder: FormBuilder) => {
    return formBuilder.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      codiceFiscale: ['', [Validators.required, Validators.pattern('^[A-Za-z0-9]{16}$')]],
      dateOfBirth: ['', [Validators.required]],
      via: ['', [Validators.required]],
      indirizzo: ['', [Validators.required]],
      civico: ['', [Validators.required]],
      cap: ['', [Validators.required, Validators.pattern(/^-?(0|[0-9]\d*)?$/)]],
      provincia: ['', [Validators.required, Validators.pattern('^[A-Za-z]{2,3}$')]],
      citta: ['', [Validators.required]]
    });
  }

  onSubmit() {

    this.spinnerService.start();

    this.success = false;
    this.submitted = true;
    this.error = false;

    if (this.registrationForm.invalid) {
      this.commonUtilService.findInvalidControls(this.registrationForm);
      this.spinnerService.stop();
      return;
    }

    let dataJSON = {
      firstName: this.val.firstName,
      lastName: this.val.lastName,
      codiceFiscale: this.val.codiceFiscale,
      dateOfBirth: this.val.dateOfBirth,
      via: this.val.via,
      indirizzo: this.val.indirizzo,
      civico: this.val.civico,
      cap: this.val.cap,
      provincia: this.val.provincia,
      citta: this.val.citta
    }

    this.reportService.updateCandidate(this.requestNumber, this.uuid, dataJSON).subscribe(data => {
      /* console.log(data); */
      this.showForm = false;
      /* this.success = true; */
      this.goToSuccessPage();
      this.spinnerService.stop();
    }, err => {
      this.error = true;
      this.spinnerService.stop();
    });
  }

  getConfirmation() {
    let modalElem = <HTMLInputElement>document.querySelector("#launchModal");
    modalElem.click();
  }

  open(content) {
    this.modalReference = this.modalService.open(content);
    this.modalReference.result.then((result) => {
      if (result === '1') {
        this.onSubmit();
      }
      this.modalReference.close();
    });

  }

}
